// Note these sources should be private to VMPlayer, but at the moment they are dependency required via the TemperatureProbeQuestion to be part of the main source
// the fix is probably to have a stub TemperatureProbeQuestion on Desktop that simply says "Not supported" - that said, it may actually be possible to get BLE temp probes
// to work on desktop aswell, but that is another story :D
import "./connectable-device";
import "./temperature-probe-manager";